import { AddressElement } from '@stripe/react-stripe-js'
import { FC } from 'react'
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'

interface PaymentMethodAddressFieldProps {
  onChange?: (event: StripeAddressElementChangeEvent) => void
  onFocus?: () => void
  heapEventName?: string
}

export const PaymentMethodAddressField: FC<PaymentMethodAddressFieldProps> = ({
  onChange,
  onFocus,
  heapEventName
}) => {
  const handleOnChange = (event: StripeAddressElementChangeEvent): void => {
    fireAnalyticsEvent(`${heapEventName}_Changed` || 'Revenue_Upgrade_Changed_BillingDetails')
    if (onChange) onChange(event)
  }
  const handleFocus = (): void => {
    fireAnalyticsEvent(
      `${heapEventName}_Focused` || 'Revenue_Upgrade_Focused_BillingDetails_Focused'
    )
    onFocus?.()
  }
  return (
    <AddressElement
      options={{
        mode: 'billing',
        autocomplete: { mode: 'automatic' }
      }}
      onChange={handleOnChange}
      onFocus={handleFocus}
    />
  )
}
